// Force Cart Drawer to Open
(function() {
  // Wait for DOM content to be loaded
  window.addEventListener('DOMContentLoaded', function() {
    console.log('OCS cart fix loaded - DOM ready');
    initCartFix();
  });
  
  // Also try after window load for good measure
  window.addEventListener('load', function() {
    console.log('OCS cart fix loaded - Window loaded');
    initCartFix();
  });
  
  function initCartFix() {
    // Check if fix is already initialized
    if (window._ocsCartFixInitialized) return;
    window._ocsCartFixInitialized = true;
    
    // 1. Check for cart drawer and log its state
    const cartDrawer = document.querySelector('cart-drawer');
    console.log('Cart drawer found:', !!cartDrawer);
    if (cartDrawer) {
      console.log('Cart drawer methods:', {
        open: typeof cartDrawer.open === 'function',
        renderContents: typeof cartDrawer.renderContents === 'function'
      });
    }
    
    // 2. Intercept all OCS form submissions
    document.querySelectorAll('.ocs-card form').forEach(function(form) {
      console.log('Found OCS form:', form.id);
      
      form.addEventListener('submit', function(event) {
        event.preventDefault();
        console.log('Form submission intercepted:', this.id);
        
        // Get the variant ID
        const variantInput = this.querySelector('input[name="id"]');
        if (!variantInput || !variantInput.value) {
          console.error('No variant selected');
          return;
        }
        
        // Show loading state on the button
        const submitBtn = this.querySelector('button[type="submit"]');
        if (submitBtn) {
          submitBtn.classList.add('loading');
          submitBtn.setAttribute('disabled', 'disabled');
        }
        
        // Add to cart via fetch
        const formData = new FormData(this);
        const params = new URLSearchParams(formData);
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: params
        })
        .then(response => response.json())
        .then(item => {
          console.log('Item added to cart:', item);
          
          // Now try multiple approaches to open the cart drawer
          openCartDrawer();
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          window.location.href = '/cart';
        })
        .finally(() => {
          // Reset button state
          if (submitBtn) {
            submitBtn.classList.remove('loading');
            submitBtn.removeAttribute('disabled');
          }
        });
      });
    });
    
    // 3. Define a function to try multiple cart drawer opening methods
    function openCartDrawer() {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) {
        console.error('Cart drawer not found, redirecting to cart page');
        window.location.href = '/cart';
        return;
      }
      
      // Method 1: Try using the built-in open method
      if (typeof cartDrawer.open === 'function') {
        try {
          cartDrawer.open();
          console.log('Cart opened via open() method');
          return;
        } catch (e) {
          console.warn('Error using open() method:', e);
        }
      }
      
      // Method 2: Try setting the 'open' attribute
      try {
        cartDrawer.setAttribute('open', '');
        console.log('Cart opened via setAttribute');
        return;
      } catch (e) {
        console.warn('Error setting open attribute:', e);
      }
      
      // Method 3: Try using inline styles
      try {
        cartDrawer.style.transform = 'translateX(0)';
        console.log('Cart opened via style transform');
        return;
      } catch (e) {
        console.warn('Error setting style:', e);
      }
      
      // Method 4: Try adding a class
      try {
        cartDrawer.classList.add('drawer--open');
        cartDrawer.classList.add('is-open');
        cartDrawer.classList.add('open');
        console.log('Cart opened via classes');
        return;
      } catch (e) {
        console.warn('Error adding classes:', e);
      }
      
      // Method 5: Try dispatching an event
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        console.log('Dispatched cart events');
        return;
      } catch (e) {
        console.warn('Error dispatching events:', e);
      }
      
      // If all else fails, redirect to cart
      console.error('All cart drawer opening methods failed, redirecting to cart');
      window.location.href = '/cart';
    }
    
    // 4. Also fix the toggleVariant function
    if (typeof window.toggleVariant === 'function') {
      const originalToggleVariant = window.toggleVariant;
      
      window.toggleVariant = function(variantId, productId, circleEl) {
        console.log('Toggle variant called:', variantId, productId);
        
        // Call original function
        originalToggleVariant(variantId, productId, circleEl);
        
        // Ensure the variant ID is correctly set
        const form = document.getElementById('ocs-product-form-' + productId);
        if (form) {
          const variantInput = form.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = variantId;
          }
          
          // Make sure button is properly updated
          const submitBtn = form.querySelector('button[type="submit"]');
          if (submitBtn) {
            if (variantId) {
              submitBtn.textContent = 'ADD TO CART';
              submitBtn.classList.remove('disabled');
              submitBtn.removeAttribute('disabled');
            } else {
              submitBtn.textContent = 'SELECT SIZE';
              submitBtn.classList.add('disabled');
              submitBtn.setAttribute('disabled', 'true');
            }
          }
        }
      };
    }
  }
})();